module.exports = __webpack_public_path__ + "components/flag/static/square/bi-7f3b2046fdbe8a5b257636342305c6ae.svg";